import React from 'react';
import {ReactKeycloakProvider} from '@react-keycloak/web';
import {BrowserRouter} from 'react-router-dom';
import {ClientConfigProvider} from './contexts/ClientConfigContext';
import {ThemeProvider} from './contexts/ThemeProvider';
import {QuadralLoaderProvider} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import AppContent from './components/AppContent';
import useKeycloakConfig from './hooks/useKeycloakConfig';
import './App.css';

const App = () => {
    const keycloak = useKeycloakConfig();

    if (!keycloak) {
        return null;
    }

    return (
        <ClientConfigProvider>
            <ThemeProvider>
                <ReactKeycloakProvider
                    authClient={keycloak}
                    initOptions={{
                        onLoad: 'login-required',
                        checkLoginIframe: false
                    }}
                >
                    <QuadralLoaderProvider>
                        <BrowserRouter>
                            <AppContent/>
                        </BrowserRouter>
                    </QuadralLoaderProvider>
                </ReactKeycloakProvider>
            </ThemeProvider>
        </ClientConfigProvider>
    );
};

export default App;